/**
 * Created by piotr.pozniak@thebeaverhead.com on 06/04/2019.
 */

const initialState = {
  collection: [],

  fetch: false,
  fetchSuccess: false,
  fetchError: null,

  startCheckoutSession: false,
  startCheckoutSessionSuccess: false,
  startCheckoutSessionError: null,
  checkoutSession: null,

  stripeBillingPortalLinkFetch: false,
  stripeBillingPortalLinkFetchSuccess: false,
  stripeBillingPortalLinkFetchError: null,
  stripeBillingPortalLink: null,

  stripePaymentLinkFetch: false,
  stripePaymentLinkFetchSuccess: false,
  stripePaymentLinkFetchError: null,
  stripePaymentLink: null,

  stripeCustomerSessionFetch: false,
  stripeCustomerSessionFetchSuccess: false,
  stripeCustomerSessionFetchError: null,
  stripeCustomerSession: null,
};

export default function reducer(
  state = { ...initialState, collection: [] },
  action
) {
  switch (action.type) {
    case "SUBSCRIPTION_CHECKOUT_SESSION_CREATE":
      return {
        ...state,
        startCheckoutSession: true,
        startCheckoutSessionSuccess: false,
        startCheckoutSessionError: null,
        checkoutSession: null,
      };

    case "SUBSCRIPTION_CHECKOUT_SESSION_CREATE_FULFILLED":
      return {
        ...state,
        startCheckoutSession: false,
        startCheckoutSessionSuccess: true,
        checkoutSession: action.payload,
      };

    case "SUBSCRIPTION_CHECKOUT_SESSION_CREATE_REJECTED":
      return {
        ...state,
        startCheckoutSession: false,
        startCheckoutSessionSuccess: false,
        startCheckoutSessionError: action.payload,
      };

    case "SUBSCRIPTION_CUSTOMER_PORTAL_LINK_FETCH":
      return {
        ...state,
        stripeBillingPortalLinkFetch: true,
        stripeBillingPortalLinkFetchSuccess: false,
        stripeBillingPortalLinkFetchError: null,
        stripeBillingPortalLink: null,
      };

    case "SUBSCRIPTION_CUSTOMER_PORTAL_LINK_FETCH_FULFILLED":
      return {
        ...state,
        stripeBillingPortalLinkFetch: false,
        stripeBillingPortalLinkFetchSuccess: true,
        stripeBillingPortalLink: action.payload,
      };

    case "SUBSCRIPTION_CUSTOMER_PORTAL_LINK_FETCH_REJECTED":
      return {
        ...state,
        stripeBillingPortalLinkFetch: false,
        stripeBillingPortalLinkFetchSuccess: false,
        stripeBillingPortalLinkFetchError: action.payload,
      };

    case "SUBSCRIPTION_PAYMENT_LINK_FETCH":
      return {
        ...state,
        stripePaymentLinkFetch: true,
        stripePaymentLinkFetchSuccess: false,
        stripePaymentLinkFetchError: null,
        stripePaymentLink: null,
      };

    case "SUBSCRIPTION_PAYMENT_LINK_FETCH_FULFILLED":
      return {
        ...state,
        stripePaymentLinkFetch: false,
        stripePaymentLinkFetchSuccess: true,
        stripePaymentLink: action.payload,
      };

    case "SUBSCRIPTION_PAYMENT_LINK_FETCH_REJECTED":
      return {
        ...state,
        stripePaymentLinkFetch: false,
        stripePaymentLinkFetchSuccess: false,
        stripePaymentLinkFetchError: action.payload,
      };

    case "SUBSCRIPTION_CUSTOMER_SESSION_FETCH":
      return {
        ...state,
        stripeCustomerSessionFetch: true,
        stripeCustomerSessionFetchSuccess: false,
        stripeCustomerSessionFetchError: null,
        stripeCustomerSession: null,
      };
    case "SUBSCRIPTION_CUSTOMER_SESSION_FETCH_FULFILLED":
      return {
        ...state,
        stripeCustomerSessionFetch: false,
        stripeCustomerSessionFetchSuccess: true,
        stripeCustomerSession: action.payload,
      };

    case "SUBSCRIPTION_CUSTOMER_SESSION_FETCH_REJECTED":
      return {
        ...state,
        stripeCustomerSessionFetch: false,
        stripeCustomerSessionFetchSuccess: false,
        stripeCustomerSessionFetchError: action.payload,
      };

    case "CLEAR_ERRORS":
      return {
        ...initialState,
        collection: {
          ...state.collection,
        },
      };

    default:
      return state;
  }

  return state;
}
